import * as api from 'syft-acp-core/api/resources'
import { takeLatestApiCall } from './helpers'

export default function* root() {
  yield takeLatestApiCall('NO_SHOW_REASONS_FETCH', api.fetchNoShowReasons)
}
